import React from 'react';
import { Outlet } from 'react-router-dom';

const CharterRouter: React.FC = () => {
  return <Outlet />;
};

export default CharterRouter;
